// Shared copy + constants for the /demo video page, used by both the runtime
// SEO component (DemoSEO) and the build-time prerendered head (seo-head.ts).
import { SITE_URL, type Lang } from "@/lib/seo";

export const DEMO_PATH_FR = "/demo";
export const DEMO_PATH_EN = "/en/demo";

/** Video file lives in the repo (public/), never on a temporary host. */
export const DEMO_VIDEO_SRC = "/refound-demo.mp4";
export const DEMO_POSTER_SRC = "/refound-demo-poster.jpg";
/** Full-resolution master (2160x3840, HEVC), offered as a download only. */
export const DEMO_VIDEO_4K_SRC = "/refound-demo-4k.mp4";
export const DEMO_VIDEO_URL = `${SITE_URL}${DEMO_VIDEO_SRC}`;
export const DEMO_POSTER_URL = `${SITE_URL}${DEMO_POSTER_SRC}`;

/** ISO 8601 duration of the clip (21 s). */
export const DEMO_DURATION = "PT21S";
export const DEMO_UPLOAD_DATE = "2026-10-23";

export function demoSeo(lang: Lang) {
  const isFr = lang === "fr";
  return {
    title: isFr
      ? "Démo vidéo — Plus besoin de chercher le reçu | ReFound"
      : "Video demo — No more hunting for receipts | ReFound",
    description: isFr
      ? "Démonstration de ReFound en 21 secondes : montrez simplement l'objet et l'application retrouve son reçu, sa garantie et son délai de retour."
      : "A 21-second ReFound demo: just show the item and the app finds its receipt, warranty and return window.",
    imageAlt: isFr
      ? "ReFound — démo vidéo : montrez l'objet, trouvez le reçu"
      : "ReFound — video demo: show the item, find the receipt",
  };
}
